import { produce } from 'immer'
import moment from 'moment'
import _ from 'lodash'

export interface ExportFormatFields {
  [key: string]: 'toUpperCase' | 'toLowerCase' | 'toTitleCase' | 'formatDate'
}

export function getDownloadResults(
  downloadRequests: any | undefined,
  formatFields?: ExportFormatFields | undefined,
): any | undefined {
  return produce(downloadRequests, (draftState: any) => {
    draftState.forEach(function (o: any) {
      Object.keys(o).forEach(function (key: any) {
        if (formatFields !== undefined) {
          if (formatFields[key] === 'formatDate' && o[key] !== null) {
            o[key] = moment(o[key]).format('MM-DD-YYYY')
          } else if (formatFields[key] === 'toUpperCase' && o[key] !== null) {
            o[key] = o[key].toUpperCase()
          } else if (formatFields[key] === 'toLowerCase' && o[key] !== null) {
            o[key] = o[key].toLowerCase()
          } else if (formatFields[key] === 'toTitleCase' && o[key] !== null) {
            o[key] = _.startCase(_.toLower(o[key]))
          }
        }
        if (o[key] === null) {
          o[key] = ''
        }
      })
    })
  })
}
